module.exports = __webpack_public_path__ + "img/mike-subedi.70c444a2.jpg";